import React, { Component } from 'react';
import { Button, Checkbox, Grid } from 'semantic-ui-react';
import { FloatingLabelInput as Input } from '../Elements';
import { PropTypes } from 'prop-types';
import Formsy from 'formsy-react';
import styles from './Leads.scss';
import { Analytics, GlobalNotifications, Intent } from '../Modules';
import { graphql, commitMutation } from 'react-relay';

class RecaptchaSettings extends Component {
  static propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const {
      s_recaptcha_enabled,
      s_recaptcha_site_key,
      s_recaptcha_secret_key
    } = this.props.viewer;
    this.state = {
      submitted: false,
      submitting: false,
      recaptchaSettings: {
        s_recaptcha_enabled,
        s_recaptcha_site_key,
        s_recaptcha_secret_key
      },
      dirtyInputs: false,
      showSecretKey: false
    };
    this.onValidRecaptchaSubmit = this.onValidRecaptchaSubmit.bind(this);
    this.onInvalidRecaptchaSubmit = this.onInvalidRecaptchaSubmit.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.checkboxChange = this.checkboxChange.bind(this);
    this.toggleSecretKey = this.toggleSecretKey.bind(this);
  }

  onInvalidRecaptchaSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update reCAPTCHA settings',
      intent: Intent.DANGER
    });
  }

  onValidRecaptchaSubmit() {
    this.setState({ submitting: true, submitted: true });
    this.updateRecaptchaSettings();
  }

  checkboxChange(e, data) {
    this.setState({
      recaptchaSettings: Object.assign({}, this.state.recaptchaSettings, {
        s_recaptcha_enabled: data.checked
      }),
      dirtyInputs: true
    });
  }

  textFieldChange(e) {
    this.setState({
      recaptchaSettings: Object.assign({}, this.state.recaptchaSettings, {
        [e.target.name]: e.target.value
      }),
      dirtyInputs: true
    });
  }

  toggleSecretKey() {
    this.setState({ showSecretKey: !this.state.showSecretKey });
  }

  updateRecaptchaSettings() {
    const onError = () => {
      this.setState({ submitting: false });
      GlobalNotifications.show({
        message: 'Unable to update reCAPTCHA settings',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      this.setState({ submitting: false, dirtyInputs: false });
      GlobalNotifications.show({
        message: 'Successfully updated reCAPTCHA settings',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-recaptcha-settings');
    };

    const mutation = graphql`
      mutation RecaptchaSettings_UpdateUserMutation($input: UpdateUserInput!) {
        updateUser(input: $input) {
          user {
            s_recaptcha_enabled
            s_recaptcha_site_key
            s_recaptcha_secret_key
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.props.viewer.id,
          ...this.state.recaptchaSettings
        }
      },
      onCompleted,
      onError
    });
  }

  render() {
    const { dirtyInputs, showSecretKey, submitting } = this.state;
    return (
      <Formsy.Form
        onValidSubmit={this.onValidRecaptchaSubmit}
        onInvalidSubmit={this.onInvalidRecaptchaSubmit}
      >
        <Grid padded relaxed stackable>
          <Grid.Row>
            <Grid.Column width={5} className={styles.settingsLabels}>
              <p>
                <strong>reCAPTCHA</strong>
              </p>
              <p className={styles.helperText}>
                <em>
                  Receiving spam? Require users to solve a challenge before
                  submitting their forms to filter out automated submissions.
                </em>
              </p>
            </Grid.Column>
            <Grid.Column width={11}>
              <Checkbox
                label='Enable reCAPTCHA Verification'
                onChange={this.checkboxChange}
                name='s_recaptcha_enabled'
                checked={this.state.recaptchaSettings.s_recaptcha_enabled}
                style={{ paddingBottom: '2em' }}
              />
              <p>
                You will need to register your website for reCAPTCHA in order
                to enable this feature. If you don't already have an account,{' '}
                please <a href='https://www.google.com/recaptcha/admin/create'>
                create one here</a> to get site and secret keys.{' '}
              </p>
              <p>
                Please be sure to use <strong>reCAPTCHA v2</strong> and select
                the <strong>"I'm not a robot" Checkbox</strong> option.
              </p>
              {this.state.recaptchaSettings.s_recaptcha_enabled &&
                <div>
                  <Input
                    label='Site key'
                    type='text'
                    name='s_recaptcha_site_key'
                    value={this.state.recaptchaSettings.s_recaptcha_site_key || ''}
                    onChange={this.textFieldChange}
                    required
                    validationError='Site key is required'
                    submitted={this.state.submitted}
                  />
                  <Input
                    label='Secret key'
                    type={showSecretKey ? 'text' : 'password'}
                    name='s_recaptcha_secret_key'
                    value={this.state.recaptchaSettings.s_recaptcha_secret_key || ''}
                    onChange={this.textFieldChange}
                    required
                    validationError='Secret key is required'
                    submitted={this.state.submitted}
                  />
                  <p>
                    <a onClick={this.toggleSecretKey}>
                      {showSecretKey ? 'Hide' : 'Show'} secret key
                    </a>
                  </p>
                </div>}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5} />
            <Grid.Column width={11}>
              {dirtyInputs && <Button
                primary
                type='submit'
                content={submitting ? 'Saving...' : 'Save'}
                disabled={submitting}
              />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Formsy.Form>
    );
  }
}

export default RecaptchaSettings;



// WEBPACK FOOTER //
// ./webpack/components/Leads/RecaptchaSettings.js